import { responsiveVariables } from "../../../utilities/props.js";
import "./align.css";
const align = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-align", value),
    };
};
export default align;
